import { render, staticRenderFns } from "./addanonydialog.vue?vue&type=template&id=11cffcb0&scoped=true"
import script from "./addanonydialog.vue?vue&type=script&lang=js"
export * from "./addanonydialog.vue?vue&type=script&lang=js"
import style0 from "./addanonydialog.vue?vue&type=style&index=0&id=11cffcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cffcb0",
  null
  
)

export default component.exports